<template>
    <nav>
        <v-app-bar app flat>

            <v-app-bar-nav-icon v-if="drawer" class="grey--text" @click="drawer = !drawer"></v-app-bar-nav-icon>
            <v-app-bar-nav-icon v-else class="grey lighten-1--text" @click="drawer = !drawer"></v-app-bar-nav-icon>

            <v-toolbar-title class="text-uppercase grey--text">
                <span class="font-weight-light">Books</span>
                <span>Uploader</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text color="grey" 
                @click="logout"
                v-if="this.$store.state.currentUser !== null">
                <span>Logout</span>
                <v-icon right>fas fa-sign-out-alt</v-icon>
            </v-btn>
        </v-app-bar>

        <v-navigation-drawer app class="indigo" v-model="drawer">
            <v-list>
                <v-list-item v-for="link in links" :key="link.text" router :to="link.route">
                    <v-list-item-icon>
                        <v-icon class="white--text">{{ link.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title class="white--text">{{ link.text }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
    </nav>
</template>

<script>
import { auth } from '@/plugins/firebase'

export default {
    name: 'Navbar',
    data:  () => ({
        drawer: false,
        links: [
            {icon: 'fa-chalkboard-teacher', text: 'Home', route: '/'},
            // {icon: 'fa-folder-open', text: 'My Projects', route: '/projects'},
            // {icon: 'fa-users', text: 'Team', route: '/about'},
            // {icon: 'fa-user-circle', text: 'Login', route: '/login'},
        ],
    }),
    computed: {
    },
    methods: {
        async logout() {
            await auth.signOut()
            this.$router.replace({name: 'Login'})
        }
    }
};
</script>

